export const CART_INTERACTION_LOCATION = {
  CART_ICON: 'cartIcon',
  VIEW_BAG: 'viewBag',
  QUICK_VIEW: 'cart viewed: quick view',
  CART_PAGE: 'cartPage',
  CART_QUICK_VIEW: 'cartPage:quickview',
};

export const CART_REMOVE_FROM_CART_LOCATION = {
  UPDATES: 'cartPage:updates',
  UPDATES_OOS_BOTTOMSHEET: 'cartPage:updatesoosbottomsheet',
  UPDATES_OOS_BOTTOMSHEET_REMOVE_ALL: 'cartPage:updatesoosbottomsheet:removeall',
};

export const CART_EVENTS = {
  CART_PAGELOAD: 'cart_viewed',
  CART_UPDATES_POPUP: 'cart_updates_popup',
  CART_UPDATES_OOS_BOTTOMSHEET: 'cart_updates_oos_bottomsheet',
  CART_UPDATES_SELLER_BOTTOMSHEET: 'cart_updates_seller_bottomsheet',
  CHECKOUT_CLICKED: 'checkout_clicked',
  CHECKOUT_ACTION_ERROR: 'checkout_action_error',
  MP_REMOVE_FROM_CART: 'remove_from_cart',
  MP_CART_QUANTITY_UPDATE: 'cart_quantity_update',
  CART_PRODUCT_VIEW: 'cart_product_view',
  CART_PRODUCT_QUICK_VIEW_CLICKED: 'cart_product_quick_view',
  CART_PRODUCT_QUICK_VIEW_BOTTOM_SHEET_CLOSED: 'cart_product_quick_view_bottom_sheet_closed',
  CART_PRODUCT_QUICK_VIEW_DETAILS_CTA_CLICKED: 'cart_product_quick_view_details_cta_clicked',
  CART_CHARGES_I_ICON_CLICK: 'charges_i_icon_click',
  CART_SIZE_UPDATE: 'cart_size_updated',
  CART_ITEM_SELECT_TOGGLE: 'cart_item_select_toggle',
  CART_SIZE_SELECTOR_CLICKED: 'cart_size_selector_clicked',
  CART_ITEM_SIZE_UPDATED: 'cart_item_size_updated',
};
